/**
 * Tipuri pentru fenomenotipul AK (keratoză actinică) — sursă: Prisma (backend)
 * `enum AkPhenotypeType`, `enum AkSeverity`, `enum AkSpecialArea`.
 *
 * Sunt date-only (fără backend): frontendul le folosește pentru selectoarele
 * din pasul 3 (Leziuni) și pentru validarea locală înainte de salvare.
 */

export enum AkPhenotypeType {
  /** Leziune unică, izolată. */
  UNIQUE = 'UNIQUE',
  /** Câmp (field) keratozic pe o zonă vizibilă. */
  FIELD_ON_VISIBLE_AREA = 'FIELD_ON_VISIBLE_AREA',
  /** AK extinsă / difuză. */
  WIDESPREAD = 'WIDESPREAD',
  /** Leziuni multiple grupate. */
  MULTIPLE_GROUPED = 'MULTIPLE_GROUPED',
  /** Cancerizare de câmp. */
  FIELD_CANCERIZATION = 'FIELD_CANCERIZATION',
  /** Pacient imunocompromis. */
  IMMUNOCOMPROMISED = 'IMMUNOCOMPROMISED',
  /** Localizare într-o zonă specială (buză inferioară, urechi, etc.). */
  SPECIAL_AREA = 'SPECIAL_AREA',
}

export enum AkSeverity {
  I = 'I',
  II = 'II',
  III = 'III',
}

/** Zone speciale pentru AK (sursă medicală: buză inferioară, urechi, fața dorsală a mâinilor, antebraț, gambe). */
export enum AkSpecialArea {
  LOWER_LIP = 'LOWER_LIP',
  EARRS = 'EARRS',
  DORSAL_HAND = 'DORSAL_HAND',
  FOREARM = 'FOREARM',
  LEG = 'LEG',
}

export const AK_PHENOTYPE_OPTIONS: Array<{ value: AkPhenotypeType; label: string }> = [
  { value: AkPhenotypeType.UNIQUE, label: 'Leziune unică' },
  { value: AkPhenotypeType.FIELD_ON_VISIBLE_AREA, label: 'Câmp keratozic pe zonă vizibilă' },
  { value: AkPhenotypeType.WIDESPREAD, label: 'AK extinsă / difuză' },
  { value: AkPhenotypeType.MULTIPLE_GROUPED, label: 'Leziuni multiple grupate' },
  { value: AkPhenotypeType.FIELD_CANCERIZATION, label: 'Cancerizare de câmp' },
  { value: AkPhenotypeType.IMMUNOCOMPROMISED, label: 'Pacient imunocompromis' },
  { value: AkPhenotypeType.SPECIAL_AREA, label: 'Localizare în zonă specială' },
];

export const AK_SEVERITY_OPTIONS: Array<{ value: AkSeverity; label: string }> = [
  { value: AkSeverity.I, label: 'Grad I' },
  { value: AkSeverity.II, label: 'Grad II' },
  { value: AkSeverity.III, label: 'Grad III' },
];

export const AK_SPECIAL_AREA_OPTIONS: Array<{ value: AkSpecialArea; label: string }> = [
  { value: AkSpecialArea.LOWER_LIP, label: 'Buză inferioară' },
  { value: AkSpecialArea.EARRS, label: 'Urechi' },
  { value: AkSpecialArea.DORSAL_HAND, label: 'Fața dorsală a mâinii' },
  { value: AkSpecialArea.FOREARM, label: 'Antebraț' },
  { value: AkSpecialArea.LEG, label: 'Gambă' },
];

/** Label în română pentru un fenomenotip AK (folosit și în mesajele de validare). */
export const akPhenotypeLabel = (phenotype: AkPhenotypeType | null | undefined): string =>
  AK_PHENOTYPE_OPTIONS.find((o) => o.value === phenotype)?.label ?? '—';
